export default __webpack_public_path__ + "static/Plots0015-b282c11ec369c2e1cc6d4349ce49b625.jpg";